import { memo, useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { RoutePath } from 'consts/RoutePath';
import { Hr } from 'components/atoms/Hr';
import classes from './override.module.scss';
import { ApiError } from 'requests/RequestBase';
import { UserWithGroupAuth, callGetOutFamilyApi } from 'requests/RequestGroup';
import { findSexTypeNameByKey } from 'consts/SexConst';
import { findGroupAuthByKey } from 'consts/GroupAuthConst';
import { HttpStatus } from 'consts/HttpStatus';
import { CircularProgress } from '@material-ui/core';
import { BirthDay } from 'components/molecules/BirthDay';

type Props = {};
type GetOutFamilyDto = {
	groupId: string;
	targetUser: UserWithGroupAuth;
	loginUser: UserWithGroupAuth;
};

export const GetOutFamilyTemplate = memo((_props: Props) => {
	const history = useHistory<GetOutFamilyDto>();
	const dto = history.location.state;
	const user = dto.targetUser;
	const auth = findGroupAuthByKey(user);
	const [page, setPage] = useState(0);
	const [processLoading, setProcessLoading] = useState(false);
	const [actionError, setActionError] = useState('');
	const isActionError = actionError !== '';

	const [timer, setTimer] = useState(undefined);
	const backToMyPage = () => {
		clearTimeout(timer);
		history.push(RoutePath.MY_PAGE);
	};
	const getOutFamily = async () => {
		setProcessLoading(true);
		// 家族からはずす
		const result = await callGetOutFamilyApi(dto.groupId, user.gidpk);
		if (result.status !== HttpStatus.OK) {
			const errorData = result.data as ApiError;
			setActionError(errorData.message);
			setProcessLoading(false);
			return;
		}
		setProcessLoading(false);

		const timer = setTimeout(function () {
			history.push(RoutePath.MY_PAGE);
		}, 5000);
		setTimer(timer);

		setPage((prev) => prev + 1);
	};

	const scrollRef = useRef(null);
	useEffect(() => {
		scrollRef.current.scrollIntoView();
		document.title = 'ユーザー情報';
	}, []);

	const errorRef = useRef(null);
	useEffect(() => {
		if (isActionError) {
			errorRef.current.scrollIntoView();
		}
	}, [actionError]);

	return (
		<>
			<section className="section mypage" ref={scrollRef}>
				<div className="breadcrumb">
					<ul>
						<li>
							<Link to={RoutePath.MY_PAGE}>マイページTOP</Link>
						</li>
						<li>
							<Link to={RoutePath.FAMILY_INFO}>家族情報</Link>
						</li>
						<li>ユーザーの情報</li>
					</ul>
				</div>
				{page === 0 && (
					<div className="section-in" style={{ marginTop: 50 }}>
						<div className="section-head">
							<p>以下のユーザーを「家族」のコミュニティからはずしますか？</p>
							<img className={classes.memberInfoIcon} src={`${process.env.PUBLIC_URL}/images/${auth.image}`} alt="" />
							<span>{auth.name}</span>
						</div>

						{isActionError ? (
							<div className="error-box" ref={errorRef}>
								<p>{actionError}</p>
							</div>
						) : null}

						<div className="info-box">
							<div className="info-head">メールアドレス/GakkenID</div>
							<div className="info-txt">{`${user.mailaddress_1}/${user.gid}`}</div>
							<Hr />
							<div className="info-head">お名前（全角）</div>
							<div className="info-txt">{`${user.lastname}　${user.firstname}`}</div>
							<Hr />
							<div className="info-head">お名前（カナ）</div>
							<div className="info-txt">{`${user.kana_lastname}　${user.kana_firstname}`}</div>
							<Hr />
							<div className="info-head">生年月日</div>
							<div className="info-txt">
								<BirthDay birth={user.birth} isFlexStart={true} />
							</div>
							<Hr />
							<div className="info-head">性別</div>
							<div className="info-txt">{findSexTypeNameByKey(user.sex) || '　'}</div>

							<div className="btn-box">
								{processLoading ? (
									<CircularProgress />
								) : (
									<>
										<div className="btn wh">
											<button onClick={getOutFamily}>「家族」からはずす</button>
										</div>
										<div className="btn gr">
											<Link to={RoutePath.MY_PAGE}>
												<span>マイページTOPへ戻る</span>
											</Link>
										</div>
									</>
								)}
							</div>
						</div>
					</div>
				)}
				{page === 1 && (
					<div className="section-in" style={{ marginTop: 50 }}>
						<div className="thankyou-box">
							<img src="images/img-complete.svg" alt="完了しました" />
						</div>
						<p>
							<div>5秒後に自動的にマイページTOPへ戻ります</div>
						</p>
						<div className="btn-box">
							<div className="btn gr">
								<button onClick={backToMyPage}>マイページTOPへ戻る</button>
							</div>
						</div>
					</div>
				)}
			</section>
		</>
	);
});
